import {default as HamrahCheckBox} from './HamrahCheckBox-Component';
export default HamrahCheckBox;
